import { render, staticRenderFns } from "./LetterAdd.vue?vue&type=template&id=38965f26"
import script from "./LetterAdd.vue?vue&type=script&lang=js"
export * from "./LetterAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38965f26')) {
      api.createRecord('38965f26', component.options)
    } else {
      api.reload('38965f26', component.options)
    }
    module.hot.accept("./LetterAdd.vue?vue&type=template&id=38965f26", function () {
      api.rerender('38965f26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/dispenseManagement/components/LetterAdd.vue"
export default component.exports